import { useSelector } from 'react-redux';
import GlobalErrorBanner from '../GlobalErrorBanner/GlobalErrorBanner';
import ErrorToast from '../ErrorToast/ErrorToast';
import { selectErrors } from '../../../slices/errorSlice';
import styles from './ErrorRenderer.module.css';

const ErrorRenderer = () => {
  const errors = useSelector(selectErrors);

  return (
    <>
      {/* Render GlobalErrorBanner for app-wide critical errors */}
      {errors
        .filter((error) => error.type === 'CRITICAL')
        .map((error) => (
          <GlobalErrorBanner key={error.id} id={error.id} message={error.message} />
        ))}

      {/* Render ErrorToast for transient errors */}
      <div className={styles.toastContainer}>
        {errors
          .filter((error) => error.type === 'TOAST')
          .map((error) => (
            <ErrorToast key={error.id} id={error.id} message={error.message} />
          ))}
      </div>
    </>
  );
};

export default ErrorRenderer;
